export const TENANTS = {
    'localhost:8080': ['X57Y8ZXYKL39R', '8XPMNZPMK64WY'],
    'testen-und-gutes-tun.de': ['X57Y8ZXYKL39R', '8XPMNZPMK64WY'],
    'testenundgutestun.de': ['X57Y8ZXYKL39R', '8XPMNZPMK64WY'],
    'testeninronsdorf.de': ['X57Y8ZXYKL39R', '8XPMNZPMK64WY'],
    'testeninoberhausen.de': ['GN5W9Z57ZJYL4', '6X7M5ZJRZ4YPN'],
    'awg-test.de': ['6M8N9ZM4KL4G7'],
}
